var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$slots.default && _vm.$slots.default.length)?_c('VueSlickCarousel',_vm._b({ref:"carosel"},'VueSlickCarousel',_vm.settings,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }